import React, { useEffect, useState } from "react";
import { auth, provider, providerApple } from "./config";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  getAdditionalUserInfo,
  OAuthProvider,
} from "firebase/auth";
import {
  CssBaseline,
  TextField,
  ThemeProvider,
  createMuiTheme,
} from "@mui/material";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SignIn from "./SignIn";
import { signupFlask } from "../Api/data";
import AdditionalDetails from "../Guest/AdditionalDetails";
import { getUserData } from "../Api/homeapi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PhoneAuth from "./Box/PhoneAuth";
import { getUser_phoneDetails } from "../Api/firebaseAPis";
import { Modal } from "antd";
// import Navigation from '../navigator/Navigation'
const customStyles = {
  control: (base, state) => ({
    ...base,
    background: "#141414",
    text: "#fff",
    font: "#fff",
    color: "#fff",
    // match with the menu
    borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
    // Overwrittes the different states of border
    borderColor: state.isFocused ? "grey" : "grey",
    // Removes weird border around container
    boxShadow: state.isFocused ? null : null,
    "&:hover": {
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "grey" : "grey",
    },
  }),
  menu: (base) => ({
    ...base,
    background: "#141414",
    borderRadius: 0,
    // kill the gap
    padding: 10,
    marginTop: 0,
    text: "#EAEAEA",
    font: "#EAEAEA",
    color: "#EAEAEA",
  }),
  menuList: (base) => ({
    ...base,
    background: "#141414",
    text: "#fff",
    padding: 0,
  }),
};
const theme = createMuiTheme({
  palette: {
    type: "dark",
  },
});
function Main() {
  const [value, setValue] = useState("");
  const [showAP, setShowAP] = useState(false);
  const phoneNumber = useSelector((state) => state.Auth).phoneNumber;
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(
    localStorage.getItem("phone") ? false : true
  );
  const [isModalopen, setisModalopen] = useState(false);
  const [last_name, setlast_name] = useState("");
  const [first_name, setfirst_name] = useState("");
  const [gender, setGender] = useState("");
  const [userdata, setuserdata] = useState(undefined);
  const [dob, setdob] = useState(new Date());
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn")
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = async () => {
    const authDataG = await signInWithPopup(auth, provider).then((data) => {
      setValue(data.user.email);
      localStorage.setItem("uid", data.user.uid);
      localStorage.setItem("email", data.user.email);
      localStorage.setItem("name", data.user.displayName);
      return data;
    });
    const { isNewUser } = getAdditionalUserInfo(authDataG);
    console.log(isNewUser)
    if (isNewUser) {
      let fName = "Unavailable";
      let lName = "";
      if (authDataG.user["displayName"]) {
        fName = authDataG.user["displayName"].split(" ")[0];
        fName && setfirst_name(fName);
        lName = authDataG.user["displayName"].split(" ")[1];
        lName && setlast_name(lName);
      }
      const userDataToSend = {
        firstname: fName,
        lastname: lName,
        uid: authDataG.user["uid"],
        displayName: authDataG.user["displayName"],
        username: "",
        email: authDataG.user["email"],
        userObj: authDataG.user,
      };
      let signdata = await signupFlask(userDataToSend);
      
      setShowAP(true);
      dispatch({
        type: "SET_SHOW_NAVIGATOR",
        showNavigator: false,
      });
    }
    localStorage.setItem("isLoggedIn", true);
    dispatch({
      type: "SET_LOGGED_IN",
      isLoggedIn: true,
    });
    setIsLoggedIn(true);
    if(localStorage.getItem('uid')){
      navigate('/add')
    }         
  };

 
  const signInWithApple = async () => {
    const provider = providerApple;
    provider.addScope('email');
    provider.addScope('name');
    provider.setCustomParameters({
      // Localize the Apple authentication screen in French.
      locale: "en-gb",
    });

    const result = await signInWithPopup(auth, provider)
      .then((data) => {
        console.log(data)
        setValue(data.user.email);
        localStorage.setItem("uid", data.user.uid);
        localStorage.setItem("email", data.user.email);
        localStorage.setItem("name", data.user.displayName);
        return data;
      })
      .catch((error) => {
        alert(error);
      });
    const { isNewUser } = getAdditionalUserInfo(result);
   
    if (isNewUser) {
      let fName = "Unavailable";
      let lName = "";
      if (result.user["displayName"]) {
        fName = result.user["displayName"].split(" ")[0];
        fName && setfirst_name(fName);
        lName = result.user["displayName"].split(" ")[1];
        lName && setlast_name(lName);
      }
      const userDataToSend = {
        firstname: fName,
        lastname: lName,
        uid: result.user["uid"],
        displayName: result.user["displayName"],
        username: "",
        email: result.user["email"],
        userObj: result.user,
      };
      signupFlask(userDataToSend);
      setShowAP(true);
      dispatch({
        type: "SET_SHOW_NAVIGATOR",
        showNavigator: false,
      });
    }
    localStorage.setItem("isLoggedIn", true);
    dispatch({
      type: "SET_LOGGED_IN",
      isLoggedIn: true,
    });   
    setIsLoggedIn(true);
    if(localStorage.getItem('uid')){
      navigate('/add')
    }   
  };

  const handleLoginWithCred = async (email, password) => {
    await signInWithEmailAndPassword(auth, email, password).then((data) => {
    
      setValue(data.user.email);

      localStorage.setItem("uid", data.user.uid);
      localStorage.setItem("email", data.user.email);
      localStorage.setItem("name", data.user.displayName);
      localStorage.setItem("isLoggedIn", true);
      dispatch({
        type: "SET_LOGGED_IN",
        isLoggedIn: true,
      });
      setIsLoggedIn(true);
    });
  };


  useEffect(() => {
  
    if (isLoggedIn === "true" || isLoggedIn === true) {
     
      setValue(localStorage.getItem("email"));
      
      getuser();
    }
  }, [value, isLoggedIn]);

  const getuser = async () => {

    let uidX = localStorage.getItem("uid");
    const uD = await getUserData(uidX);
    setuserdata(uD);
    localStorage.setItem("user", uD);

    if (!uD.username) {
      setShowAP(true);
    } else {
      navigate('/home')
    }
  };

  
 
  return (
    <>
      <div>
        <meta
          name="apple-itunes-app"
          content="app-id=1643038656, app-argument=https://apps.apple.com/us/app/surge-party/id1643038656"
        ></meta>
        (
          <SignIn
            handleClick={handleClick}
            signInWithApple={signInWithApple}
            handleLoginWithCred={handleLoginWithCred}
          />
        )
      </div>

    
     
    </>
  );
}

export default Main;
